<template>
    <div class="forex-index">
        <page-navigate></page-navigate>
        <div>
            <div class="forex-wrapper cn">
                <forexMenu />

                <div class="forex-wrapper-body">
                    <div id="searchApp" data-language="cn">
                        <h1 class="">交易专业术语</h1>
                        <p class="forex-title-intro">
                            涵盖差价合约、期货、股票等金融市场专业术语，助您快速理解交易世界的语言
                        </p>

                        <div id="search-box-index">
                            <div class="search-box">
                                <el-autocomplete ref="autocomplete" @keydown.enter.native="handleSearch"
                                    prefix-icon="el-icon-search" :fetch-suggestions="querySearchAsync"
                                    :trigger-on-focus="false" placeholder="输入关键词" v-model="searchValue"
                                    class="input-with-select" value-key="label">
                                    <template slot-scope="{ item }">
                                        <a :href="item.url" class="custom-template" v-html="item.value"></a>
                                    </template>
                                    <div slot="prepend" v-if="!isMobile">
                                        <el-select v-model="typeValue" placeholder="">
                                            <el-option v-for="type in searchTypeList" :label="type.name"
                                                :value="type.id" :key="type.id"></el-option>
                                        </el-select>
                                        <div class="search-line"></div>
                                    </div>
                                    <div style="height: 100%; display: flex; align-items: baseline" slot="suffix">
                                        <span v-if="searchValue" @click="searchValue = ''">
                                            <i class="el-icon-error search-clean-icon"></i>
                                        </span>
                                        <a href="javascript:;" @click.stop="handleSearch" class="my-search-btn">搜索</a>
                                    </div>
                                </el-autocomplete>
                            </div>
                        </div>
                        <ul class="ul-Alphabet no-scrollbar">
                            <li class="li-letter" v-for="letter in Alphabet"
                                :class="{ 'isSelested': currentLetter == letter }" @click="handleLetterClick(letter)"
                                :data-letter="letter">
                                {{ letter }}
                            </li>
                        </ul>
                    </div>
                    <section class="section1 letter-list" >
                        <div name="finalList" id="group" v-for="group in dataList" :key="group.letter">
                            <div class="letter-item" :data-letter="group.letter">
                                <div class="letter-item-title">
                                    <h3>{{ group.letter }}</h3>
                                    <div v-if="group.showMore">
                                        <div class="btn-text">
                                            显示更多<span class="iconfont icon-chevron_right"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dictionary-card">
                                    <div class="dictionary-item" v-for="item in group.items" :key="item.id">
                                        <a
                                            :href="item.url.replace('/zh-cn','')">{{ item.post_short_title ? item.post_short_title : item.post_title }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getSearchSuggestions, getAcademyDictionary } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

let searchTypeList = [
    { id: "all", name: "全部", parent_id: 0, children: [] },
    { id: 142, name: "交易词典", parent_id: 0, children: [] },
    { id: 4, name: "金融知识", parent_id: 0, children: [] },
    { id: 143, name: "市场传奇", parent_id: 0, children: [] },
    { id: 8, name: "金融焦点", parent_id: 0, children: [] },
    { id: 7, name: "数据报告", parent_id: 0, children: [] },
    { id: 146, name: "市场期刊", parent_id: 0, children: [] },
];
let lang = "zh-cn";
const words = [
    '外汇', '保证金', '炒汇', '炒币', 'CFD', '差价合约',
    '虚拟货币', '加密货币', '数字货币', '比特币', 'BTC',
    '以太坊', 'ETH', '台湾', '出金', '入金', '现货'
];
function selectLetterItem(letter) {
    // Remove isSelected class from all letter items
    const allLetterItems = document.querySelectorAll(".letter-item");
    allLetterItems.forEach((item) => {
        item.classList.remove("isSelected");
    });

    // Add isSelected class to the matching letter item
    const targetItem = document.querySelector(
        `.letter-item[data-letter="${letter}"]`
    );
    if (targetItem) {
        targetItem.classList.add("isSelected");
    }
}

function scrollToLetterItem(letter, isMobile) {
    let targetItem = document.querySelector(
        `.letter-item[data-letter="${letter}"]`
    );

    // If target item doesn't exist, find the previous letter that exists
    if (!targetItem) {
        // Create an array of all letters in order
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        const currentIndex = alphabet.indexOf(letter);

        // Search backwards through the alphabet
        for (let i = currentIndex - 1; i >= 0; i--) {
            const prevLetter = alphabet[i];
            targetItem = document.querySelector(
                `.letter-item[data-letter="${prevLetter}"]`
            );
            if (targetItem) {
                break;
            }
        }
    }

    // If we found a target item (either the original or a fallback), scroll to it
    if (targetItem) {
        const offset = isMobile ? 160 : 100; // 100px offset
        const elementPosition =
            targetItem.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
}
export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            searchValue: "",
            typeValue: "all",
            searchTypeList: searchTypeList,
            isMobile: false,
            searchValue: "",
            isMobile: false,
            currentLetter: "A",
            currentLanguage: "cn", // 默认语言
            dataList: [],
            loading:false,

            // 所有语言的字母表映射
            alphabetMap: {
                cn: [
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "#",
                ],
            },
            typeValue: 142,
        }
    },
    computed: {
        // 根据当前语言返回对应的字母表
        Alphabet() {
            return this.alphabetMap[this.currentLanguage] || this.alphabetMap.cn;
        },
    },
    created() {
        this.loading = true;
        getAcademyDictionary().then(response => {
            if (response.status && response.status == '200') {
                this.dataList = response.data.data
            }
            this.loading = false
        }).catch(err => {
            this.dataList = [];
             this.loading = false
        })
    },
    mounted() {
        this.checkScreenWidth(); // 初始化判断
        window.addEventListener("resize", this.checkScreenWidth); // 监听窗口变化

        // 显示更多切换
        document.querySelectorAll(".btn-text").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.preventDefault();

                const letterItem = this.closest(".letter-item");

                letterItem.classList.toggle("isShowMore");
            });
        });
    },
    filters: {},
    methods: {
        handleLetterClick(item) {
            this.currentLetter = item;
            selectLetterItem(item);
            scrollToLetterItem(item, this.isMobile);
        },
        querySearchAsync(queryString, cb) {
            getSearchSuggestions(queryString, this.typeValue).then((response) => {
                if (response.status && response.status == "200" && response.data && response.data.status && response.data.status == "success") {
                    let result = response.data.data.suggestions.map((el) => {
                        return {
                            value: el.title,
                            url: el.url.replace("/zh-cn", ""),
                            label: el.title.replace(/<em>(.*?)<\/em>/g, "$1"),
                        };
                    });
                    let result2 = result.filter(item => {
                        // 检查 label 是否包含 words 中的任意一个词
                        const hasForbiddenWord = words.some(word =>
                            item.label.includes(word)
                        );
                        return !hasForbiddenWord; // 不包含才保留
                    })
                    cb(result2);
                } else {
                    cb([]);
                }
            }).catch((error) => {
                cb([]);
            });
        },
        checkScreenWidth() {
            this.isMobile = window.innerWidth <= 996;
        },
        // 搜索跳转
        handleSearch() {
            if (!this.searchValue) {
                return;
            }
            this.$router.push(`/jinrong/search?sort=${this.typeValue}&word=${this.searchValue}`);
        },

    },
}
</script>
<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.title-intro {
    margin-top: 10rem;
    color: #232222;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

#search-box-index {
    margin-top: 32rem;
}

.ul-Alphabet {
    position: sticky;
    margin-top: 26rem;
    display: flex;
    justify-content: space-between;
    gap: 20rem;
}

.li-letter {
    color: #000;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    cursor: pointer;
}

.isSelested,
.li-letter:hover {
    color: #a52933 !important;
}

.isSelested {
    font-weight: 700;
}

.section1 {
    margin-top: 50rem;
    display: flex;
    flex-direction: column;
    gap: 36rem;
}

.letter-item-title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.letter-item-title h3 {
    color: #232222;
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.isSelected .letter-item-title h3 {
    color: #a52933;
}

.btn-text {
    display: inline-flex;
    align-items: baseline;
    gap: 4rem;
    flex-shrink: 0;
    color: #6a6967;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
}

.isShowMore .btn-text .icon-chevron_right {
    transform: rotate(270deg);
}

.btn-text .icon-chevron_right {
    font-size: 16rem;
    line-height: 1.3;
    transition: all 0.3s;
    transform: rotate(90deg);
}

.isShowMore .dictionary-card {
    max-height: 5000rem;
}

.dictionary-card {
    margin-top: 16rem;
    display: flex;
    flex-wrap: wrap;
    gap: 20rem 0;
    padding: 26rem 24rem;
    border-radius: 8rem;
    border: 1rem solid #e1e6ed;
    overflow: hidden;
    transition: all 0.3s;
}

.dictionary-item {
    width: 25%;
    padding-right: 10rem;
    height: 20rem;
    line-height: normal;
    overflow: hidden;
}

.dictionary-item a {
    position: relative;
    padding-left: 16rem;
    padding-right: 30rem;
    color: #232222;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 20rem;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.dictionary-item a:hover {
    color: #a52933;
    font-weight: 700;
}

.dictionary-item a:hover::before {
    color: #a52933;
}

.dictionary-item a::before {
    font-family: "iconfont" !important;
    content: "\e618";
    position: absolute;
    left: 0;
    /* top: 0; */
    font-size: 14rem;
    color: #B2AFAD;
    line-height: 21rem;
    /* transform: rotate(180deg); */
}

.ar .dictionary-item a {
    padding-left: 30rem;
    padding-right: 16rem;
}

.ar .dictionary-item a::before {
    transform: rotate(180deg);
    left: unset;
    right: 0;
}

.dictionary-item .isSelested {
    font-weight: 700;
    color: #a52933 !important;
}

@media (max-width: 996px) {
    #search-box-index {
        margin-top: 42rem;
    }

    .title-intro {
        margin-top: 18rem;
        font-size: 28rem;
    }

    .ul-Alphabet {
        margin-top: 36rem;
        width: 100%;
        overflow-x: auto;
        gap: 40rem;
    }

    .li-letter {
        font-size: 28rem;
    }

    .letter-item-title h3 {
        font-size: 40rem;
    }

    .btn-text {
        font-size: 28rem;
    }

    .btn-text .icon-chevron_right {
        font-size: 28rem;
        line-height: normal;
    }

    .dictionary-card {
        /*max-height: 222rem;*/
    }

    .dictionary-item {
        width: 100%;
        height: auto;
        padding-right: 0;
    }

    .dictionary-item a {
        padding-left: 0;
        font-size: 28rem;
        line-height: 42rem;
        height: 42rem;
        white-space: nowrap;
        /* 禁止换行 */
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 溢出时显示省略号 */
        padding-right: 40rem;
    }

    .dictionary-item a::before {
        left: unset;
        right: 0;
        font-size: 28rem;
        line-height: 43rem;
    }
}
</style>